import React from 'react';
import { bool, func, string } from 'prop-types';

import { LinkAsButton } from '@johnlewispartnership/wtr-ingredients/ingredients/LinkAsButton';

import urls from 'constants/urls';

const SignOutButton = ({
  className,
  isSignedOnAsCustomer,
  loggedIn,
  onBlur = null,
  onClick = null,
  onFocus = null,
  width,
}) => {
  if (loggedIn && !isSignedOnAsCustomer) {
    return (
      <LinkAsButton
        className={className}
        component="a"
        data-test="signOut"
        href={urls.logout}
        label="Sign out"
        onBlur={onBlur}
        onClick={onClick}
        onFocus={onFocus}
        theme="secondary"
        type="button"
        width={width}
      />
    );
  }

  return null;
};

SignOutButton.propTypes = {
  className: string,
  isSignedOnAsCustomer: bool.isRequired,
  loggedIn: bool.isRequired,
  onBlur: func,
  onClick: func,
  onFocus: func,
  width: string,
};

SignOutButton.displayName = 'SignOutButton';

export default SignOutButton;
